import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useBenchmark from '../../../../hooks/dashboard/performance-monitoring/useBenchmark';
import {
  ThresholdDataType,
  ThresholdInitialValues,
  ThresholdSchema,
} from '../../../../models/dashboard/performance-monitoring/threshold';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import NumberOnlyInputField from '../../../FormCom/NumberOnlyInputField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';

const RatingThresholdModal = () => {
  const modalContext = useContext(ModalContext);
  const { setBenchmark, loading } = useBenchmark();

  const successActionFn = () => {
    modalContext?.setShowModal(false);
  };

  const onSubmit = (value: ThresholdDataType) => {
    setBenchmark(value, () => {
      modalContext?.setShowSuccessComponent(true);
      modalContext?.setSuccessDescription(
        `Performance score updates after ${value.threshold} deliveries`,
      );
    });
  };

  return (
    <ModalContainer
      label='Set Rating Threshold'
      description='Minimum number of completed trips before rating counts toward performance.'
      successComponent={() => (
        <PlainSuccessModal
          successActionFn={successActionFn}
          successLabel='Success'
          description={modalContext?.successDescription ?? ''}
          btnLabel='Close'
          // className='pink'
        />
      )}
      showSuccessComponent={modalContext?.showSuccessComponent}
    >
      <FormComponent
        initialValues={ThresholdInitialValues}
        schema={ThresholdSchema}
        onSubmit={onSubmit}
        className={'large-gap'}
      >
        <NumberOnlyInputField
          label=''
          name='threshold'
          id='threshold'
          type='text'
          placeholder='0'
        />

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Save Threshold
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default RatingThresholdModal;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
